import * as React from 'react';

// redux
import {ICommonViewProps} from '../../views/ViewContainer';
import {connect} from "react-redux";

// translations
import {translate} from 'react-i18next';

// components
import {Icon} from 'semantic-ui-react';
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import {compose, Dispatch} from 'redux';
import HATEOASClient from 'src/services/HATEOASClient';
import {MenuDto} from 'src/services/Client';
import {selectBaseLinks, selectClient, selectSupportArealinks} from '../../redux/selectors';
import {IReduxState} from 'src/redux/IReduxState';
import SupportViewActions from '../../redux/actions/SupportViewActions';

interface IMapStateToProps {
    client: HATEOASClient;
    supportAreaLinks: MenuDto | undefined;
    baseLinks: MenuDto | undefined;
}

interface IMapDispatchToProps {
    RequestSupportAreaLinks: (baseLinks: MenuDto | undefined) => void;
}

interface JavaMelodyMonitoringProps extends ICommonViewProps, IMapStateToProps, IMapDispatchToProps { }

class JavaMelodyMonitoring extends React.Component<JavaMelodyMonitoringProps> {
    constructor(props: JavaMelodyMonitoringProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.baseLinks) {
            this.props.RequestSupportAreaLinks(this.props.baseLinks);
        }
    }

    componentWillReceiveProps(newProps: JavaMelodyMonitoringProps) {
        if (!this.props.baseLinks && newProps.baseLinks) {
            this.props.RequestSupportAreaLinks(newProps.baseLinks);
        }
    }

    redirectToTarget() {
        if (this.props.supportAreaLinks) {
            if (this.props.client.GET_monitoring(this.props.supportAreaLinks).canExecute()) {
                this.props.client.GET_monitoring(this.props.supportAreaLinks).execute()
                    .then((path: string) => {
                        const userStr = JSON.stringify(path);

                        JSON.parse(userStr, (key, value) => {
                            if (typeof value === 'string') {
                                window.location.href = window.location.origin + value;
                            }
                        });
                    })
                    .catch((reason: any) => {
                        renderErrorToast({
                            message: "ERRORS:JAVA_MONITORING_FAIL",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            }
        }
    }

    render() {
        const {t} = this.props;

        return (
            <div className="bottom-tooltip">
                <Icon
                    name={'clock'}
                    size={'small'}
                    circular={true}
                    inverted={true}
                    link={true}
                    onClick={() => this.redirectToTarget()}
                />
                <span className="tooltiptext">{t("JAVA_MONITORING_HINT")}</span>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    baseLinks: selectBaseLinks(state),
    client: selectClient(state),
    supportAreaLinks: selectSupportArealinks(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    RequestSupportAreaLinks: (baseLinks) => dispatch(SupportViewActions.RequestSupportAreaLinks(baseLinks))
});

export default compose(
    translate("SUPPORT_VIEW"),
    connect<IMapStateToProps>(mapStateToProps, mapDispatchToProps)
)(JavaMelodyMonitoring);



// WEBPACK FOOTER //
// ./src/components/JavaMonitoring/JavaMonitoring.tsx